export type ProbsError = {
  detail?: string;
};

export type Probs<E extends ProbsError = ProbsError> = {
  title?: string;
  status?: number;
  detail?: string;
  errors?: E[];
};

const nonEmpty = (value: unknown): value is string => typeof value === 'string' && value.trim().length > 0;

export const isProbs = (value: unknown): value is Probs => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const candidate = value as Probs;
  return nonEmpty(candidate.title) || Array.isArray(candidate.errors);
};

export const probsText = (probs: Probs): string | null => {
  const heading = [probs.title, probs.detail].filter(nonEmpty).join(' ');
  const entries = (probs.errors ?? [])
    .map(error => error.detail)
    .filter(detail => detail !== probs.detail)
    .filter(nonEmpty)
    .map(detail => `  - ${detail}`);
  if (entries.length === 0) return nonEmpty(heading) ? heading : null;
  if (!nonEmpty(heading)) return entries.join('\n');
  return [heading, 'Details:', ...entries].join('\n');
};
